import classNames from "classnames";
import { ReactNode } from "react";

export type ButtonVariants = "default" | "outline" | "secondary" | "text";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariants;
  onClick?: (e: unknown) => void;
  text?: string | ReactNode;
}

const Button = ({ variant = "default", onClick, text, className, type = "button", ...props }: ButtonProps) => {
  const variantProps = {
    default: {
      className:
        "w-full flex items-center justify-center text-base rounded-full bg-brand-purple disabled:bg-brand-purple-lighter p-0.5 hover:bg-brand-purple-light text-white font-bold h-[50px] shadow-md hover:cursor-pointer",
    },
    secondary: {
      className:
        "w-full flex items-center justify-center text-base rounded-full bg-navy-blue p-0.5 disabled:bg-navy-blue-lighter text-white hover:bg-navy-blue-light font-bold h-[50px] shadow-md hover:cursor-pointer",
    },
    outline: {
      className:
        "w-full flex items-center justify-center text-base rounded-full border-2 box-border border-brand-purple hover:border-0 hover:p-0.5 disabled:bg-brand-purple-lighter bg-white hover:bg-brand-purple-light text-brand-purple hover:text-white font-bold h-[50px] shadow-md hover:cursor-pointer",
    },
    text: {
      className: "w-full flex items-center justify-center text-base text-navy-blue p-0.5 h-[50px] hover:cursor-pointer",
    },
  };
  return (
    <button
      data-testid={`button-${variant}-variant`}
      type={type}
      aria-label={typeof text === "string" ? text : ""}
      onClick={onClick}
      className={classNames(variantProps[variant].className, className)}
      {...props}
    >
      {text}
    </button>
  );
};

export default Button;
